<script setup lang="ts">
/**
 * Row of mutually-exclusive pill buttons — the recurring "pick one" control
 * in the settings forms (heading level, grid columns, alignment, width,
 * text size, background…).
 */
defineProps<{
  options: ReadonlyArray<{ value: string | number, label: string }>
  modelValue: string | number | undefined
}>()

defineEmits<{ 'update:modelValue': [value: string | number] }>()
</script>

<template>
  <div class="flex gap-1.5">
    <UButton
      v-for="option in options"
      :key="option.value"
      size="xs"
      :color="modelValue === option.value ? 'primary' : 'neutral'"
      :variant="modelValue === option.value ? 'solid' : 'outline'"
      @click="$emit('update:modelValue', option.value)"
    >
      {{ option.label }}
    </UButton>
  </div>
</template>
